<template>
  <div class="jp-common-layout ">
    <div class="jp-common-layout-left" style="width: 370px;">
      <div class="jp-common-title flexTreeTitle"> 
          <el-input
            placeholder="请输入关键字进行过滤"
            style="width: 245px;"
            size="small"
            clearable
            v-model="filterText">
          </el-input>
          <div>
            <el-button @click="searchTree('search')" size="small" type="primary" circle   icon="el-icon-search"></el-button>
            <el-button @click="searchTree('expandAll')" size="small" type="primary" circle   icon="fa fa-random"></el-button>
          </div>
        </div>
        <div class="jp-common-el-tree-scrollbar el-scrollbar">
          <div class="el-scrollbar__wrap" :style="{height: treeHeight-40 +'px',marginTop: '20px'}">
            <div class="el-scrollbar__view">
                <vxe-table
                  show-overflow
                  border="none"
                  ref="xTree"
                  :loading="loading"
                  :show-header="false"
                  :tree-config="{transform: true, rowField: 'id', parentField: 'parentId',expandAll: treeExpandAll,reserve:true}"
                  :radio-config="{labelField: 'nameCn'}"
                  :row-config="{keyField:'id',isCurrent: true, isHover: true}"
                  :data="showTreeList">
                  <vxe-column field="nameCn"   tree-node>
                    <template slot-scope="scope">
                      <div class="treeSpan" @click="handRow(scope.row)">{{ scope.row.name }}</div>
                    </template>
                  </vxe-column>
                </vxe-table>
            </div>
          </div>
        </div>
    </div>
    <div class="jp-common-layout-center jp-flex-main">
      <div class="page">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
              <!-- 搜索框-->
            <el-form-item prop="proCode">
                  <el-input size="small" v-model="searchForm.proCode" placeholder="项目编号" clearable></el-input>
            </el-form-item>
            <el-form-item prop="name">
                  <el-input size="small" v-model="searchForm.name" placeholder="项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item prop="kindId1">
              <el-select
                v-model="searchForm.kindId1"
                clearable
                placeholder="工程类别"
                style="width: 180px"
                @change="handCategories"
              >
                <el-option
                  v-for="item in kindCategoriesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="kindId2">
              <el-select
                v-model="searchForm.kindId2"
                clearable
                placeholder="工程类型"
                style="width: 180px"
              >
                <el-option
                  v-for="item in kindTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="workUnitId">
              <el-select
                v-model="searchForm.workUnitId"
                clearable
                placeholder="施工单位"
                style="width: 180px"
              >
                <el-option
                  v-for="item in $dictUtils.getDictList('cec_build_section')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
              <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>

      <div class="bg-white top">
          <vxe-toolbar>
            <template #buttons>
              <!-- <el-button v-if="hasPermission('cecproject:cecProject:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button> -->
              <!-- <el-button v-if="hasPermission('cecproject:cecProject:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecProjectTable && $refs.cecProjectTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
              <!-- <el-button v-if="hasPermission('cecproject:cecProject:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecProjectTable && $refs.cecProjectTable.getCheckboxRecords().length === 0" plain>删除</el-button> -->
              <el-button v-if="hasPermission('cecproject:cecproject:getproject')" @click="getCecProject()" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC项目数据</el-button>
              <el-button v-if="hasPermission('cecproject:cecproject:getKind')" @click="getCecDataSheet('Kind')" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC项目类别类型数据</el-button>
              <el-button v-if="hasPermission('cecproject:cecproject:getCategory')" @click="getCecDataSheet('Category')" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC项目物品类型数据</el-button>
              <el-button v-if="hasPermission('cecproject:cecproject:getUnit')" @click="getCecDataSheet('Unit')" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC项目物品单位数据</el-button>
            </template>
          </vxe-toolbar>
          <div style="height: calc(100% - 130px);">
          <vxe-table
              border="full"
              auto-resize
              resizable
              height="auto"
              :loading="loading"
              size="small"
              ref="cecProjectTable"
              show-header-overflow
              show-overflow
              highlight-hover-row
              :scroll-y="{enabled: true}"
              :menu-config="{}"
              :print-config="{}"
              :import-config="{
              importMethod: importMethod,
                  types: ['csv', 'xls', 'xlsx'],
                  remote: true,
              }"
              :export-config="{
                  remote: true,
                  filename: `项目表数据${moment(new Date()).format(
                  'YYYY-MM-DD'
                  )}`,
                  sheetName: '项目表数据',
                  exportMethod: exportMethod,
                  types: ['xlsx'],
                  modes: ['current', 'selected', 'all'],
              }"
              @sort-change="sortChangeHandle"
              :sort-config="{remote:true}"
              :data="dataList"
              :checkbox-config="{}">
              <vxe-column type="checkbox"  width="40px" align="center" fixed="left"></vxe-column>
              <vxe-column type="seq" width="50" fixed="left" align="center" title="序号"></vxe-column>
              <!-- <vxe-column
          field="isFinish"
          fixed="left"
          align="center"
          width="80"
          title="配置状态">
          <template slot-scope="scope">
            <i v-if="scope.row.isFinish == '1'" class="el-icon-check isFinishIcon colorGreen" ></i>
            <i v-else class="el-icon-close isFinishIcon colorRed" ></i>
          </template>
        </vxe-column> -->
      <vxe-column
          field="proCode"
          fixed="left"
          align="center"
          width="150"
          title="项目编号">
              <template slot-scope="scope">
                <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('cecproject:cecProject:edit')" @click="edit(scope.row.id)">{{scope.row.proCode}}</el-link> -->
                <el-link  type="primary" :underline="false" v-if="hasPermission('cecproject:cecProject:view')"  @click="view(scope.row)">{{scope.row.proCode}}</el-link>
                <span v-else>{{scope.row.proCode}}</span>
              </template>
        </vxe-column>
        <vxe-column
          field="name"
          fixed="left"
          align="center"
          width="100"
          title="项目名称">
        </vxe-column>
      <!-- <vxe-column
          field="isNeedMaterial"
          width="100"
          title="是否需要材料配置">
        </vxe-column> -->
      <vxe-column
          field="kindName1"
          width="100"
          align="center"
          title="工程类别">
        </vxe-column>
      <vxe-column
          field="kindName2"
          width="100"
          align="center"
          title="工程类型">
        </vxe-column>
      <vxe-column
          field="workPoint"
          width="150"
          align="center"
          title="施工指示">
        </vxe-column>
    
      <vxe-column
          field="workNote"
          width="150"
          align="center"
          title="注意事项">
        </vxe-column>
      <vxe-column
          field="workUnitId"
          width="100"
          align="center"
          title="施工小组">
          <template slot-scope="scope">
            <span>{{ setWorkUnitText(scope.row.workUnitId) }}</span>
          </template>
        </vxe-column>
      <vxe-column
          field="otherProjectId"
          width="80"
          align="center"
          title="涉及项目">
          <template slot-scope="scope">
                <div v-if="!scope.row.otherProjectId">
                  -
                </div>
                <PopoverTipList
                  v-else
                  labelValue = 'id'
                  tableType = "length"
                  :value = "scope.row.otherProjectId"
                  :sortDisabled="true"
                  :columns="[
                    {
                      prop: 'proCode',
                      label: '项目编号'
                    },
                    {
                      prop: 'kindName1',
                      label: '工程类别'
                    },
                    {
                      prop: 'kindName2',
                      label: '工程类型'
                    },
                    {
                      prop: 'name',
                      label: '工程项目'
                    }
                  ]"
                  :selectArray="scope.row.others"
                ></PopoverTipList>
              </template>
        </vxe-column>
      <!-- <vxe-column
          field="otherRequireProjectIds"
          width="100"
          align="center"
          title="关联其他必选工程项目编号">
        </vxe-column> -->
      <vxe-column
          field="picture"
          width="200"
          align="center"
          title="图片">
            <template slot-scope="scope">
                <PopoverTipList
                  v-if="scope.row.picJsonList.length > 0 "
                  labelValue = 'id'
                  tableType = "length"
                  tableHeight = '500px'
                  boxWidth="400"
                  :imageDisabled="true"
                  :columns="[
                    {
                      prop: 'description',
                      label: '描述'
                    },
                  ]"
                  :selectArray="scope.row.picJsonList"
                ></PopoverTipList>
                <span v-else>-</span>
              </template>
        </vxe-column>
      <vxe-column
          field="remarks"
          align="center"
          min-width="100"
          title="备注">
        </vxe-column>
        <!-- <vxe-column
          fixed="right"
          align="center"
          width="200"
          title="操作">
          <template  slot-scope="scope">
            <el-button v-if="hasPermission('cecproject:cecProject:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button>
            <el-button v-if="hasPermission('cecproject:cecProject:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button>
            <el-button v-if="hasPermission('cecproject:cecProject:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button>
          </template>
        </vxe-column> -->
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page="tablePage.currentPage"
        :page-size="tablePage.pageSize"
        :total="tablePage.total"
        :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="currentChangeHandle">
      </vxe-pager>
      </div>
      </div>
          <!-- 弹窗, 新增 / 修改 -->
      <CecProjectForm  ref="cecProjectForm" @refreshDataList="refreshList"></CecProjectForm>
    </div>
    </div>
  </div>
   
</template>

<script>
  import CecProjectForm from './CecProjectForm'
  import cecProjectService from '@/api/cecproject/cecProjectService'
  import PopoverTipList from '@/components/popoverTip/indexList.vue'
  import cecProjectKindService from '@/api/cecprojectkind/cecProjectKindService'
  export default {
    data () {
      return {
        searchForm: {
          name: '',
          proCode: '',
          kindId1: '',
          kindId2: '',
          workUnitId: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'create_date', asc: false }]
        },
        loading: false,
        workUnitIdList: [],
        kindCategoriesList: [],
        kindTypeList: [],
        filterText: '',
        officeTreeData: [],
        showTreeList: [],
        treeHeight: '',
        treeExpandAll: false,
        urlHearder: 'https://www.cecerp.com/userfiles/'
      }
    },
    components: {
      CecProjectForm,
      PopoverTipList
    },
    activated () {
      this.getProjectKind('Categories', '0')
      this.getAllProjectKind()
      this.refreshList()
      this.workUnitIdList = this.$dictUtils.getDictList('cec_build_section')
      this.treeHeight = document.getElementsByClassName('jp-common-el-tree-scrollbar')[0].offsetHeight
    },
    methods: {
       // 点击树结构
      async handRow (row) {
        if (row.parentId === '0') {
          this.searchForm.kindId1 = row.id
          this.searchForm.kindId2 = ''
          this.refreshList()
        } else {
          await this.getProjectKind('type', row.parentId)
          this.$nextTick(() => {
            this.searchForm.kindId1 = row.parentId
            this.searchForm.kindId2 = row.id
            this.refreshList()
          })
        }
      },
      // 展开和搜索树结构
      searchTree (type) {
        if (type === 'expandAll') {
          this.treeExpandAll = !this.treeExpandAll
          this.$refs.xTree.setAllTreeExpand(this.treeExpandAll)
        } else if (type === 'search') {
          let parentList = []
          if (this.filterText) {
            let filerData = this.officeTreeData.filter(item => item.name.indexOf(this.filterText) >= 0)
            filerData.forEach(item => {
              let findDate = this.officeTreeData.find(fitem => fitem.id === item.parentId)
              if (findDate) {
                parentList.push(findDate)
              }
            })
            let filterList = [...filerData, ...parentList]
            this.showTreeList = filterList
            this.$refs.xTree.setAllTreeExpand(true)
          } else {
            this.showTreeList = this.officeTreeData
          }
        }
      },
      // 获取树结构
      getAllProjectKind () {
        cecProjectKindService.allList({
          orders: [{ column: 'sort', asc: true }]
        }).then(({data}) => {
          this.officeTreeData = data
          this.showTreeList = data
        })
      },
      // 获取工程类型和类别
      getProjectKind (type, pid) {
        cecProjectKindService.getKindList(
          {
            parentId: pid,
            orders: [{ column: 'sort', asc: true }]
          }
        ).then(({data}) => {
          if (type === 'Categories') {
            this.kindCategoriesList = data
          } else {
            this.kindTypeList = data
          }
        })
      },
      // 工程类别事件处理
      handCategories (e) {
        if (e) {
          this.getProjectKind('type', e)
        } else {
          this.kindTypeList = []
        }
        this.searchForm.kindId2 = ''
      },
      setWorkUnitText (value) {
        if (!value) return
        let workUnit = value.split(',')
        let mapArray = workUnit.map(item => {
          let findDate = this.workUnitIdList.find(fitem => fitem.value === item)
          return findDate ? findDate.label : ''
        })
        return mapArray.join(',')
      },
      // 获取cec套餐项目表数据
      getCecProject () {
        this.loading = true
        cecProjectService.getCecUpdateProject({}).then(({res}) => {
          this.$message.success('获取成功')
          this.refreshList()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 获取cec套餐其他数据
      getCecDataSheet (type) {
        this.loading = true
        cecProjectService.getCecDataSheet(type).then(({res}) => {
          this.$message.success('获取成功')
          this.refreshList()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecProjectService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records.map(item => {
            item.picJsonList = []
            if (item.picJson) {
              item.picJsonList = JSON.parse(item.picJson).map(citem => {
                citem.fileUrl = this.urlHearder + citem.fileStorePath + citem.filesIn
                return citem
              })
            }
            return item
          })
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecProjectForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecProjectTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecProjectForm.init('edit', id)
      },
      // 查看
      view (data) {
        this.$router.push({path: '/cecproject/CecUnmProjectDet', query: {id: data.id, title: data.proCode + '<详情>'}})
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecProjectTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecProjectService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecProjectService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecProjectService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecProjectService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>
<style scoped>
.isFinishIcon{
  font-size:20px;
  font-weight: bold;
}
.colorRed{
  color: red;
}
.colorGreen {
  color: #268d50;
}
.flexTreeTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-scrollbar__view  .vxe-body--row.row--current {
    background-color: #ffd991 !important;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .jp-common-layout-left .vxe-body--column{
  height: 35px !important;
}
.treeSpan {
  height: 35px;
  width: 100%;
  line-height: 35px;
  cursor: pointer;
}
</style>

